import React, { useEffect, useState, useRef } from 'react'

import { Card } from 'components'
import { useLoading, useToggle } from 'hooks'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
  IReportsAcesssModel,
  reportsDatabase
} from 'services/database/reportsDatabase'
import { ReportsAcessServices } from 'services/NGT/ReportsAcess'
import { IFillCardsResponse } from 'services/NGT/ReportsEffectives'
import { ProfileUserServices } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'
import { PerfilUsuario } from 'utils/types'

import {
  ButtonsRow,
  CompanyCenter,
  ContractSupplier,
  DirectorsManagers,
  TypeDate
} from './components'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'

export type ListTypes =
  | 'centros'
  | 'fornecedor'
  | 'contratos'
  | 'empresas'
  | 'fornecedores'
  | 'subcontratadas'
const Reports: React.FC = () => {
  const { push, listen: historyListen } = useHistory()
  const { setLoading, setMsgErro } = useLoading()
  const [tipoRelatorio, setTipoRelatorio] = useState<boolean>(false)
  const [contrato, setContrato] = useState<string>('')
  const [fornecedor, setFornecedor] = useState<string>('')
  const [subcontratada, setSubContratada] = useState<string>('')
  const [empresa, setEmpresa] = useState<string>('')
  const [centro, setCentro] = useState<string>('')
  const [limpar, setLimpar] = useState<boolean>(false)

  const historyListenerRef = useRef<() => void | null>(null)
  const REPORTS_PATHS = [
    '/ngt/relatorios-acesso-contrato',
    '/ngt/relatorios-acesso-fornecedor',
    '/ngt/relatorios-acesso'
  ]

  const refUnidGestora = useRef(null)

  const handleChangeInput = (value: string, t: ListTypes) => {
    const listSets = {
      centros: (value: string) => setCentro(value),
      contratos: (value: string) => setContrato(value),
      empresas: (value: string) => setEmpresa(value),
      fornecedor: (value: string) => setFornecedor(value),
      subcontratadas: (value: string) => setSubContratada(value)
    }
    listSets[t](value)
  }

  interface IKeyValueChecked {
    id: number
    name: string
    checked?: boolean
  }

  const [contratoList, setContratoList] = useState<IKeyValueChecked[]>([])
  const [fornecedorList, setFornecedorList] = useState<IKeyValueChecked[]>([])
  const [empresaList, setEmpresaList] = useState<IKeyValueChecked[]>([])
  const [centroList, setCentroList] = useState<IKeyValueChecked[]>([])
  const [subFornecedoresList, setSubFornecedoresList] = useState<
    IKeyValueChecked[]
  >([])

  const [contratosIds, setContratosIds] = useState<number[]>([])
  const [fornecedoresIds, setFornecedoresIds] = useState<number[]>([])
  const [empresasIds, setEmpresasIds] = useState<number[]>([])
  const [centrosIds, setCentrosIds] = useState<number[]>([])
  const [subcontratadasIds, setSubcontratadasIds] = useState<number[]>([])
  const [ignoreGridName, setIgnoreGridName] = useState<
    'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas' | null
  >(null)
  const [refresh, setRefresh] = useState<boolean>(false)
  const [statusUsarioFornecedor, setStatusUsarioFornecedor] = useState<
    string | undefined
  >()
  const [perfilUsuarioId, setPerfilUsuarioId] = useState<number | undefined>()
  const [periodoValidadeIni, setPeriodoValidadeIni] = useState(null)
  const [periodoValidadeFim, setPeriodoValidadeFim] = useState(null)

  const handleChangePeriodo = (date: Date | string, type: 'inicio' | 'fim') => {
    if (type === 'inicio' && moment(date).isValid()) setPeriodoValidadeIni(date)
    if (type === 'fim' && moment(date).isValid()) setPeriodoValidadeFim(date)
  }

  const [listProfiles, setListProfiles] = useState<PerfilUsuario[]>([])
  const [loadingProfiles, toggleLoadingProfiles] = useState<boolean>(false)

  useEffect(() => {
    const getProfiles = async () => {
      toggleLoadingProfiles(true)
      try {
        const response = await ProfileUserServices().getSuppliers()
        setListProfiles(response.data)
        toggleLoadingProfiles(false)
      } catch (error: any) {
        setMsgErro('Não foi possivel obter lista de perfil de usuario')
        setLoading('error')
      }
    }
    getProfiles()
  }, [])

  useEffect(() => {
    historyListenerRef.current = historyListen((location) => {
      if (!REPORTS_PATHS.includes(location.pathname)) {
        reportsDatabase.access.delete(1)
        historyListenerRef?.current()
      }
    })
  }, [])

  const [unidadeGestoraID, setUnidadeGestoraID] = useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)
  const isFirstMountRef = useRef<boolean>(true)

  const getReportDataStorage = () => {
    reportsDatabase.access
      .where({ id: 1 })
      .first()
      .then((acessResult) => {
        if (acessResult) {
          // setUnidadeGestoraID(acessResult.unidadeGestoraId)
          setContrato(acessResult.contrato)
          setFornecedor(acessResult.fornecedor)
          setSubContratada(acessResult.subcontratada)
          setEmpresa(acessResult.empresa)
          setCentro(acessResult.centro)
          setContratosIds(
            acessResult.contratos
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setFornecedoresIds(
            acessResult.fornecedores
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setEmpresasIds(
            acessResult.empresas
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setCentrosIds(
            acessResult.centros
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setSubcontratadasIds(
            acessResult.subFornecedores
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setContratoList(
            acessResult.contratos.map((contrato) => ({
              checked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            }))
          )
          setFornecedorList(
            acessResult.fornecedores.map((fornecedor) => ({
              checked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value
            }))
          )
          setEmpresaList(
            acessResult.empresas.map((empresa) => ({
              checked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            }))
          )
          setCentroList(
            acessResult.centros.map((centro) => ({
              checked: centro.checked || false,
              id: centro.key,
              name: centro.value
            }))
          )
          setSubFornecedoresList(
            acessResult.subFornecedores.map((subfornecedor) => ({
              checked: subfornecedor.checked || false,
              id: subfornecedor.key,
              name: subfornecedor.value
            }))
          )

          setPeriodoValidadeFim(
            acessResult.fimValidade ? moment(acessResult.fimValidade) : null
          )

          setPeriodoValidadeIni(
            acessResult.inicioValidade
              ? moment(acessResult.inicioValidade)
              : null
          )

          setPerfilUsuarioId(acessResult.perfil)
          setStatusUsarioFornecedor(acessResult.status)
          setTipoRelatorio(acessResult.tipoContrato)
        }
      })
      .finally(() => {
        isFirstMountRef.current = false
      })
  }

  useEffect(() => {
    getReportDataStorage()
  }, [])

  useEffect(() => {
    if (!isFirstMountRef.current) {
      !limpar && getFillCards()
    }
  }, [
    refresh,
    unidadeGestoraID,
    statusUsarioFornecedor,
    perfilUsuarioId
  ])

  const refreshGrid = (): void => {
    setRefresh((prevState) => !prevState)
  }

  const ActionCheckbox = (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id?: number
  ) =>
  ({
    add: {
      centro: () => setCentrosIds((prevState) => [...prevState, id]),
      contrato: () => setContratosIds((prevState) => [...prevState, id]),
      empresa: () => setEmpresasIds((prevState) => [...prevState, id]),
      fornecedor: () => setFornecedoresIds((prevState) => [...prevState, id]),
      subcontratadas: () =>
        setSubcontratadasIds((prevState) => [...prevState, id])
    },
    checkAll: {
      centro: () => {
        setCentroList((prevState) =>
          prevState?.map((centro) => ({ ...centro, checked: true }))
        )
        setCentrosIds(centroList.map((centro) => centro.id))
        setIgnoreGridName('centro')
        refreshGrid()
      },
      contrato: () => {
        setContratoList((prevState) =>
          prevState?.map((contrato) => ({ ...contrato, checked: true }))
        )
        setContratosIds(contratoList.map((contrato) => contrato.id))
        setIgnoreGridName('contrato')
        refreshGrid()
      },
      empresa: () => {
        setEmpresaList((prevState) =>
          prevState?.map((empresa) => ({ ...empresa, checked: true }))
        )
        setEmpresasIds(empresaList.map((empresa) => empresa.id))
        setIgnoreGridName('empresa')
        refreshGrid()
      },
      fornecedor: () => {
        setFornecedorList((prevState) =>
          prevState?.map((fornecedor) => ({ ...fornecedor, checked: true }))
        )
        setFornecedoresIds(fornecedorList.map((fornecedor) => fornecedor.id))
        setIgnoreGridName('fornecedor')
        refreshGrid()
      },
      subcontratadas: () => {
        setSubFornecedoresList((prevState) =>
          prevState?.map((subfornecedor) => ({
            ...subfornecedor,
            checked: true
          }))
        )
        setSubcontratadasIds(
          subFornecedoresList?.map((subfornecedor) => subfornecedor.id)
        )
        setIgnoreGridName('subcontratadas')
        refreshGrid()
      }
    },
    remove: {
      centro: () =>
        setCentrosIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      contrato: () =>
        setContratosIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      empresa: () =>
        setEmpresasIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      fornecedor: () =>
        setFornecedoresIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      subcontratadas: () =>
        setSubcontratadasIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        )
    },
    unCheckAll: {
      centro: () => {
        setCentroList((prevState) =>
          prevState.map((centro) => ({ ...centro, checked: false }))
        )
        setCentrosIds([])
        // limpar && setCentroList([])
        setIgnoreGridName(null)
        refreshGrid()
      },
      contrato: () => {
        setContratoList((prevState) =>
          prevState.map((contrato) => ({ ...contrato, checked: false }))
        )
        setContratosIds([])
        // limpar && setContratoList([])
        setIgnoreGridName(null)
        refreshGrid()
      },
      empresa: () => {
        setEmpresaList((prevState) =>
          prevState.map((empresa) => ({ ...empresa, checked: false }))
        )
        setEmpresasIds([])
        // limpar && setEmpresaList([])
        setIgnoreGridName(null)
        refreshGrid()
      },
      fornecedor: () => {
        setFornecedorList((prevState) =>
          prevState.map((fornecedor) => ({ ...fornecedor, checked: false }))
        )
        setFornecedoresIds([])
        // limpar && setFornecedorList([])
        setIgnoreGridName(null)
        refreshGrid()
      },
      subcontratadas: () => {
        setSubFornecedoresList((prevState) =>
          prevState.map((subfornecedor) => ({
            ...subfornecedor,
            checked: false
          }))
        )
        setSubcontratadasIds([])
        // limpar && setSubFornecedoresList([])
        setIgnoreGridName(null)
        refreshGrid()
      }
    }
  }[actionType][grid]())

  const handleChangeItem = (
    checked: boolean,
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id: number
  ): void => {
    const actionType = checked ? 'add' : 'remove'
    let notUpdateLastGridInteraction = false

    if (
      grid === 'contrato' &&
      contratosIds.length === 1 &&
      contratosIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'fornecedor' &&
      fornecedoresIds.length === 1 &&
      fornecedoresIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'empresa' &&
      empresasIds.length === 1 &&
      empresasIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'centro' &&
      centrosIds.length === 1 &&
      centrosIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'subcontratadas' &&
      contratosIds.length === 1 &&
      subcontratadasIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true

    if (notUpdateLastGridInteraction) {
      setIgnoreGridName(null)
    } else {
      setIgnoreGridName(grid)
    }

    ActionCheckbox(actionType, grid, id)
    refreshGrid()
  }

  const DEFAULT_VALUE: IFillCardsResponse = {
    centros: [],
    contratos: [],
    empresas: [],
    fornecedores: [],
    subcontratadas: []
  }

  const fillCardsExcept = (
    cardsData: IFillCardsResponse,
    doNotFillCard: string
  ): void => {
    clearIdsLists(cardsData)
    if (doNotFillCard !== 'contrato') setContratoList(cardsData.contratos)
    if (doNotFillCard !== 'fornecedor')
      setFornecedorList(cardsData.fornecedores)
    if (doNotFillCard !== 'empresa') setEmpresaList(cardsData.empresas)
    if (doNotFillCard !== 'centro') setCentroList(cardsData.centros)
    if (doNotFillCard !== 'subcontratadas')
      setSubFornecedoresList(cardsData.subcontratadas)

    if (doNotFillCard === 'contrato') {
      const checkedIds = cardsData.contratos.map(
        (contrato) => contrato.checked && contrato.id
      )

      setContratoList((prevState) =>
        prevState.map((contrato) => ({
          ...contrato,
          checked: checkedIds.includes(contrato.id)
        }))
      )
    }
    if (doNotFillCard === 'fornecedor') {
      const checkedIds = cardsData.fornecedores.map(
        (fornecedor) => fornecedor.checked && fornecedor.id
      )

      setFornecedorList((prevState) =>
        prevState.map((fornecedor) => ({
          ...fornecedor,
          checked: checkedIds.includes(fornecedor.id)
        }))
      )
    }
    if (doNotFillCard === 'empresa') {
      const checkedIds = cardsData.empresas.map(
        (empresa) => empresa.checked && empresa.id
      )

      setEmpresaList((prevState) =>
        prevState.map((empresa) => ({
          ...empresa,
          checked: checkedIds.includes(empresa.id)
        }))
      )
    }
    if (doNotFillCard === 'centro') {
      const checkedIds = cardsData.centros.map(
        (centro) => centro.checked && centro.id
      )

      setCentroList((prevState) =>
        prevState.map((centro) => ({
          ...centro,
          checked: checkedIds.includes(centro.id)
        }))
      )
    }
    if (doNotFillCard === 'subcontratadas') {
      const checkedIds = cardsData.subcontratadas.map(
        (subfornecedor) => subfornecedor.checked && subfornecedor.id
      )

      setSubFornecedoresList((prevState) =>
        prevState.map((subfornecedor) => ({
          ...subfornecedor,
          checked: checkedIds.includes(subfornecedor.id)
        }))
      )
    }
  }

  const removeOldIds = (
    newIdsList: number[],
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas'
  ): void => {
    if (grid === 'contrato')
      setContratosIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'fornecedor')
      setFornecedoresIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'empresa')
      setEmpresasIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'centro')
      setCentrosIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'subcontratadas')
      setSubcontratadasIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
  }

  const clearIdsLists = (cardsData: IFillCardsResponse): void => {
    const contratosNewIds = cardsData.contratos?.map((item) => item.id)
    const fornecedoresNewIds = cardsData.fornecedores?.map((item) => item.id)
    const empresasNewIds = cardsData.empresas?.map((item) => item.id)
    const centrosNewIds = cardsData.centros?.map((item) => item.id)
    const subFornecedoresNewIds = cardsData.subcontratadas?.map(
      (item) => item.id
    )

    removeOldIds(contratosNewIds, 'contrato')
    removeOldIds(fornecedoresNewIds, 'fornecedor')
    removeOldIds(empresasNewIds, 'empresa')
    removeOldIds(centrosNewIds, 'centro')
    removeOldIds(subFornecedoresNewIds, 'subcontratadas')
  }

  const fillCards = (cardsData: IFillCardsResponse): void => {
    clearIdsLists(cardsData)

    setContratoList(cardsData.contratos)
    setFornecedorList(cardsData.fornecedores)
    setEmpresaList(cardsData.empresas)
    setCentroList(cardsData.centros)
    setSubFornecedoresList(cardsData.subcontratadas)
  }
  // GET CARDS
  const getFillCards = async () => {
    setLoading('loading')
    try {
      const response = await ReportsAcessServices().getCards({
        ...(centrosIds.length > 0 && { centrosIds }),
        ...(contratosIds.length > 0 && { contratosIds }),
        ...(fornecedoresIds.length > 0 && { fornecedoresIds }),
        ...(empresasIds.length > 0 && { empresasIds }),
        ...(subcontratadasIds.length > 0 && { subcontratadasIds }),
        ...(statusUsarioFornecedor !== 'none' && {
          status: statusUsarioFornecedor
        }),
        ...(perfilUsuarioId && { perfil: perfilUsuarioId }),
        ...(periodoValidadeIni && {
          dataInicio: moment(periodoValidadeIni).toDate()
        }),
        ...(periodoValidadeFim && {
          dataFim: moment(periodoValidadeFim).toDate()
        }),
        cdContrato: contrato,
        nomeCentro: centro,
        nomeSubcontratada: subcontratada,
        nomeEmpresa: empresa,
        nomeFornecedor: fornecedor,
        unidadeGestoraId: unidadeGestoraID
      })

      if (response.status !== 200) throw new Error('Erro obter dados.')

      if (ignoreGridName) {
        fillCardsExcept(response.data.entity, ignoreGridName)
      } else {
        fillCards(response.data.entity)
      }

      setLoading('idle')
      setLimpar(false)
    } catch (error: any) {
      setLoading('error')
    }
  }

  const clearUnidadeGestora = () => {
    setUnidadeGestoraID({} as IOnChangeUnidadeGestora)
    refUnidGestora.current.clearForm();
  }

  const resetPage = () => {
    setLoading('loading')
    reportsDatabase.access
      .delete(1)
      .then(() => {
        setContratosIds([])
        setCentrosIds([])
        setEmpresasIds([])
        setSubcontratadasIds([])
        setFornecedoresIds([])

        setContratoList([])
        setCentroList([])
        setEmpresaList([])
        setSubFornecedoresList([])
        setFornecedorList([])

        fillCardsExcept(DEFAULT_VALUE, '')

        setContrato('')
        setFornecedor('')
        setEmpresa('')
        setCentro('')

        setPeriodoValidadeIni(null)
        setPeriodoValidadeFim(null)
        setPerfilUsuarioId(undefined)
        setStatusUsarioFornecedor(undefined)
        clearUnidadeGestora()

        refreshGrid()


      })
      .finally(() => setLoading('idle'))
  }

  const persistItensInStorage = () => {
    const acessItensModel: IReportsAcesssModel = {
      empresa: empresa,
      centro: centro,
      contrato: contrato,
      fornecedor: fornecedor,
      subcontratada: subcontratada,
      centros: centroList.map((centro) => ({
        checked: centrosIds.includes(centro.id),
        key: centro.id,
        value: centro.name
      })),
      contratos: contratoList.map((contrato) => ({
        checked: contratosIds.includes(contrato.id),
        key: contrato.id,
        value: contrato.name
      })),
      empresas: empresaList.map((empresa) => ({
        checked: empresasIds.includes(empresa.id),
        key: empresa.id,
        value: empresa.name
      })),
      fimValidade: moment(periodoValidadeFim).toDate() || '',
      fornecedores: fornecedorList.map((fornecedor) => ({
        checked: fornecedoresIds.includes(fornecedor.id),
        key: fornecedor.id,
        value: fornecedor.name
      })),
      id: 1,
      inicioValidade: moment(periodoValidadeIni).toDate() || '',
      perfil: perfilUsuarioId,
      status: statusUsarioFornecedor,
      subFornecedores: subFornecedoresList.map((fornecedor) => ({
        checked: subcontratadasIds.includes(fornecedor.id),
        key: fornecedor.id,
        value: fornecedor.name
      })),
      tipoContrato: tipoRelatorio,
      unidadeGestoraId: unidadeGestoraID
    }

    reportsDatabase.access
      .where({ id: 1 })
      .first()
      .then((existsReport) => {
        if (existsReport) {
          reportsDatabase.access.update(1, acessItensModel)
        } else {
          reportsDatabase.access.add(acessItensModel)
        }
      })
  }

  const handleVisualizar = () => {
    const data: any = {
      centrosIds: centrosIds,
      contratosIds: contratosIds,
      dataFim: periodoValidadeFim ? moment(periodoValidadeFim).toDate() : null,
      dataIni: periodoValidadeIni ? moment(periodoValidadeIni).toDate() : null,
      empresasIds: empresasIds,
      flStatus: statusUsarioFornecedor !== 'none' ? statusUsarioFornecedor : '',
      fornecedoresIds: fornecedoresIds,
      perfil:
        listProfiles.find((prof) => prof.idPerfilUsuario == perfilUsuarioId)
          ?.txDenominacao || '',
      subcontratadasIds: subcontratadasIds,
      unidadeGestoraId: unidadeGestoraID
    }

    persistItensInStorage()

    if (tipoRelatorio) {
      push({
        pathname: '/ngt/relatorios-acesso-contrato',
        state: {
          resquestVisualizar: data
        }
      })
      return
    }

    push({
      pathname: '/ngt/relatorios-acesso-fornecedor',
      state: data
    })
  }

  function handleResetPage() {
    setLimpar(true)
    resetPage()
    setTimeout(() => {
      setLimpar(false)
    }, 300)
  }

  return (
    <Card
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <TypeDate
        tipoRelatorio={tipoRelatorio}
        changeTipo={setTipoRelatorio}
        handleChangePeriodo={handleChangePeriodo}
        dataIni={periodoValidadeIni}
        dataFim={periodoValidadeFim}
      />
      <ContractSupplier
        disableAll={limpar}
        contratos={contratoList}
        fornecedores={fornecedorList}
        getData={getFillCards}
        handleChangeItem={handleChangeItem}
        checkAll={ActionCheckbox}
        contrato={contrato}
        fornecedor={fornecedor}
        handleChangeInput={handleChangeInput}
      />
      <CompanyCenter
        getData={getFillCards}
        disableAll={limpar}
        centros={centroList}
        empresas={empresaList}
        subcontratada={subcontratada}
        subcontratadas={subFornecedoresList}
        handleChangeItem={handleChangeItem}
        checkAll={ActionCheckbox}
        handleChangeInput={handleChangeInput}
        empresa={empresa}
        centro={centro}
      />
      <DirectorsManagers
        ref={refUnidGestora}
        setUnidadeGestoraID={setUnidadeGestoraID}
        loadingProfiles={loadingProfiles}
        unidadeGestoraId={unidadeGestoraID}
        listProfiles={listProfiles}
        statusUsarioFornecedor={statusUsarioFornecedor}
        perfilUsuarioId={perfilUsuarioId}
        setStatus={setStatusUsarioFornecedor}
        setPerfil={setPerfilUsuarioId}
      />
      <ButtonsRow
        resetPage={handleResetPage}
        handleVisualizar={handleVisualizar}
        disableImprimir={true}
      />
    </Card>
  )
}

export default Reports

export interface LocalStateReports {
  allCentros: boolean
  allContratos: boolean
  allEmpresas: boolean
  allFornecedores: boolean
  allSubContratos: boolean
}
